import type { Entry, UnresolvedLink } from 'contentful';

import { clsx } from '@libs/common-next';
import type { PageProps } from '@libs/core';

import { buildPage, isResolvedLinkEntry } from '../../utils';

function filterPLPItems(items: (Entry | UnresolvedLink<'Entry'>)[] = []) {
    return items.filter(entry => isResolvedLinkEntry(entry));
}

export function ProductListPage({ entry, placement }: Readonly<PageProps>) {
    const { items, bottomItems } = entry?.fields ?? {};

    const itemsToBuild = placement === 'bottom' ? bottomItems : items;

    const filteredItemsToBuild = filterPLPItems(itemsToBuild as Entry[]);

    const children = buildPage(filteredItemsToBuild as Entry[], entry?.fields?.pageId as string);

    return (
        <div
            className={clsx(
                'product-list-page',
                placement === 'top' && 'product-list-page--top',
                placement === 'bottom' && 'product-list-page--bottom'
            )}
            data-testid="plp-layout-container"
        >
            {children}
        </div>
    );
}
